import createAPI from '../axios'
//基础信息相关API

const baseInfoSkillsTraining = {
    class: {
        queryList: config => createAPI('/baseInfoSkillsTraining/class/queryList', 'post', config),
        export: config => createAPI('/baseInfoSkillsTraining/class/export', 'post', config),
        item: config => createAPI('/baseInfoSkillsTraining/class/item', 'post', config),
        stuCombo: config => createAPI('/baseInfoSkillsTraining/class/stuCombo', 'post', config),
        jsItem: config => createAPI('/baseInfoSkillsTraining/class/jsItem', 'post', config),
        teacherList: config => createAPI('/baseInfoSkillsTraining/class/teacherList', 'post', config),
        studentList: config => createAPI('/baseInfoSkillsTraining/class/studentList', 'post', config),
        classOrderNum: config => createAPI('/baseInfoSkillsTraining/class/classOrderNum', 'post', config),
        save: config => createAPI('/baseInfoSkillsTraining/class/save', 'post', config),
        deleteById: config => createAPI('/baseInfoSkillsTraining/class/deleteById', 'post', config),
        upload: config => createAPI('/baseInfoSkillsTraining/class/upload', 'post', config),
        loadMajorCombo: config => createAPI('/baseInfoSkillsTraining/class/loadMajorCombo', 'post', config),
        batchExport: config => createAPI('/baseInfoSkillsTraining/class/batchExport', 'post', config),
        saveAutoRec: config => createAPI('/baseInfoSkillsTraining/class/saveAutoRec', 'post', config),
        allocationClassStudentList: config => createAPI('/baseInfoSkillsTraining/class/allocationClassStudentList', 'post', config),//已经分班的学生
        removeAllocationClassStudentById: config => createAPI('/baseInfoSkillsTraining/class/removeAllocationClassStudentById', 'post', config),
        allocationStudentList: config => createAPI('/baseInfoSkillsTraining/class/allocationStudentList', 'post', config),//已经分班或未分班的学生
        allocationStudentSave: config => createAPI('/baseInfoSkillsTraining/class/allocationStudentSave', 'post', config),
        checkInRec: config => createAPI('/baseInfoSkillsTraining/class/checkInRec', 'post', config),
        saveAutoCheckInRec: config => createAPI('/baseInfoSkillsTraining/class/saveAutoCheckInRec', 'post', config),
        batchClassExport: config => createAPI('/baseInfoSkillsTraining/class/batchClassExport', 'post', config),
        studentDocumentUpload: config => createAPI('/baseInfoSkillsTraining/class/studentDocumentUpload', 'post', config),
        deleteDocumentFile: config => createAPI('/baseInfoSkillsTraining/class/deleteDocumentFile', 'get', config),
        queryAllDocument: config => createAPI('/baseInfoSkillsTraining/class/queryAllDocument', 'get', config),
    },
    semester: {
        queryList: config => createAPI('/baseInfoSkillsTraining/semester/queryList', 'post', config),
        save: config => createAPI('/baseInfoSkillsTraining/semester/save', 'post', config),
        jcsj: config => createAPI('/baseInfoSkillsTraining/semester/jcsj', 'post', config),
        xqxl: config => createAPI('/baseInfoSkillsTraining/semester/xqxl', 'post', config),
        updateJcsj: config => createAPI('/baseInfoSkillsTraining/semester/updateJcsj', 'post', config),
        saveHoliday: config => createAPI('/baseInfoSkillsTraining/semester/saveHoliday', 'post', config),
    },
};

export default baseInfoSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/baseInfoSkillsTraining.js